var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenefit5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "url(#paint0_linear_11711_434)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 21.3438C17.7077 21.3438 16.6562 20.2923 16.6562 19C16.6562 17.7077 17.7077 16.6562 19 16.6562C20.2923 16.6562 21.3438 17.7077 21.3438 19C21.3438 20.2923 20.2923 21.3438 19 21.3438Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6448 20.3921L24.8099 20.8434C24.7051 21.1739 24.5719 21.4957 24.4112 21.8047L25.3679 23.3991C25.4787 23.5836 25.4494 23.8198 25.2974 23.9718L23.9718 25.2975C23.8193 25.4508 23.5827 25.4783 23.3991 25.368L21.8047 24.4113C21.4957 24.5719 21.1739 24.7051 20.8434 24.81L20.392 26.6448C20.3399 26.8535 20.1527 27 19.9375 27H18.0625C17.8473 27 17.6601 26.8535 17.6079 26.6448L17.1566 24.8099C16.8261 24.7051 16.5043 24.5719 16.1953 24.4112L14.6009 25.3679C14.4164 25.4778 14.1802 25.4494 14.0282 25.2974L12.7025 23.9718C12.5506 23.8198 12.5213 23.5836 12.632 23.3991L13.5887 21.8047C13.4281 21.4957 13.2949 21.1739 13.19 20.8434L11.3552 20.3921C11.1465 20.3399 11 20.1527 11 19.9375V18.0625C11 17.8473 11.1465 17.6601 11.3552 17.6079L13.1901 17.1566C13.2949 16.8261 13.4281 16.5043 13.5888 16.1953L12.6321 14.6009C12.5213 14.4164 12.5506 14.1802 12.7026 14.0282L14.0282 12.7025C14.1793 12.5501 14.416 12.5222 14.6009 12.632L16.1953 13.5887C16.5043 13.4281 16.8261 13.2949 17.1566 13.19L17.608 11.3552C17.6601 11.1465 17.8473 11 18.0625 11H19.9375C20.1527 11 20.3399 11.1465 20.3921 11.3552L20.8434 13.1901C21.1739 13.2949 21.4957 13.4281 21.8047 13.5888L23.3991 12.6321C23.5832 12.5218 23.8198 12.551 23.9718 12.7026L25.2975 14.0282C25.4494 14.1802 25.4788 14.4164 25.368 14.6009L24.4113 16.1953C24.5719 16.5043 24.7051 16.8261 24.81 17.1566L26.6448 17.608C26.8535 17.6601 27 17.8473 27 18.0625V19.9375C27 20.1527 26.8535 20.3399 26.6448 20.3921ZM19 14.7812C16.6737 14.7812 14.7812 16.6737 14.7812 19C14.7812 21.3263 16.6737 23.2188 19 23.2188C21.3263 23.2188 23.2188 21.3263 23.2188 19C23.2188 16.6737 21.3263 14.7812 19 14.7812Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11711_434",
    x1: 38,
    y1: 38,
    x2: -2.04925,
    y2: 35.7012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#571EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA08A8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit5);
export default __webpack_public_path__ + "static/media/benefit-5.487a278eb5755fca35ee1a9d23763792.svg";
export { ForwardRef as ReactComponent };